
import React from "react";
import { formatCurrency } from '../../utils/calculator';

interface AnnualSummaryProps {
  actualAnnualPayment: number;
}

export function AnnualSummary({ actualAnnualPayment }: AnnualSummaryProps) {
  return (
    <div className="bg-white p-6 rounded-lg border">
      <p className="text-lg text-grandpal-gray mb-2">Annual Contribution</p>
      <p className="text-3xl font-bold text-grandpal-green">
        {formatCurrency(actualAnnualPayment)}
      </p>
      <p className="text-sm text-grandpal-gray mt-4">
        Your annual contribution to the Fair Deal scheme.
      </p>
    </div>
  );
}
